import { render, staticRenderFns } from "./Retenciones.vue?vue&type=template&id=443bd2a6&scoped=true"
import script from "./Retenciones.vue?vue&type=script&lang=js"
export * from "./Retenciones.vue?vue&type=script&lang=js"
import style0 from "./Retenciones.vue?vue&type=style&index=0&id=443bd2a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443bd2a6",
  null
  
)

export default component.exports